import Base from './Base';
import ConfigView from './ConfigView';

export default {
    name: "Container",
    extends: Base,
    render(h) {
        const _positionInfo = this.layoutConfig.GetPositionInfo();

        const _emptyRowNumberList = this.layoutConfig.GetEmptyRowNumberList();

        return (
            <div class="cmn-grid-container" style={{ gridTemplateColumns: `repeat(${_positionInfo.Columns}, 1fr)` }}>
                {this.$slots.default}
                {_emptyRowNumberList.map(rowNumber => (<div
                    style={{
                        gridArea: `${rowNumber} / 1 / ${rowNumber + 1} / ${_positionInfo.Columns + 1}`,
                        height: "40px"
                    }}
                />))}
            </div>
        );
    }
};